import { ReactNode } from 'react'

import Sticky from 'app/common/templates-next/sticky'

type Props = {
  children: (stuck: boolean, shadow: boolean) => ReactNode
  updateKey?: Array<any>
  resetShift?: boolean
}

export const TheadWithSticky = ({ children, updateKey, resetShift }: Props) => {
  return (
    <Sticky updateKey={updateKey} resetShift={resetShift}>
      {(ref, stuck, shadow) => <thead ref={ref}>{children(stuck, shadow)}</thead>}
    </Sticky>
  )
}
